import axios from "axios";
import router from "../router/index";
import auth from "./auth";

const token = auth.getToken();

export default function setup() {
  axios.interceptors.request.use(function(config) {
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  });
  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      let message;
      error.response && error.response.statusText !== undefined
        ? (message = error.response.statusText)
        : (message = "Failed to load response data");
      if (error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            if (error.response.data.file) return Promise.reject(error);
            if (error.response.data) return Promise.reject(error);
            router.push({ name: "404", params: { message, error } });
            return;
          case 400:
            if (error.response.data.year) return Promise.reject(error);
            if (error.response.data) return Promise.reject(error);
            return;
          case 403:
            return Promise.reject(error);
          case 500:
            router.push({ name: "500", params: { message, error } });
            return;
          default:
            router.push({ name: "error", params: { error } });
            return Promise.reject(error);
        }
      }
    }
  );
}
